import React from 'react';
import { formatCurrencyCompact, formatStat } from '../../utils/formatters';

const DAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

function getHeatColor(value, max) {
  if (!max || max === 0) return 'bg-blue-50 text-gray-400';
  const ratio = value / max;
  if (ratio >= 0.8) return 'bg-blue-600 text-white';
  if (ratio >= 0.6) return 'bg-blue-500 text-white';
  if (ratio >= 0.4) return 'bg-blue-400 text-white';
  if (ratio >= 0.2) return 'bg-blue-200 text-blue-800';
  if (ratio > 0) return 'bg-blue-100 text-blue-700';
  return 'bg-gray-50 text-gray-400';
}

export function WeeklyHeatmap({ weeklyRevenueByWeekday, weeklyMetric, onWeeklyMetricChange }) {
  if (!weeklyRevenueByWeekday?.length) {
    return <p className="text-xs text-gray-400 text-center py-4">No weekly data available</p>;
  }

  const allValues = weeklyRevenueByWeekday.flatMap(w => w.days);
  const maxVal = Math.max(...allValues, 1);

  const metricOptions = [
    { key: 'revenue', label: 'Revenue' },
    { key: 'sessions', label: 'Sessions' },
    { key: 'transactions', label: 'Transactions' },
    { key: 'conversionRate', label: 'Conv. Rate' },
  ];

  const formatVal = (v) => {
    if (weeklyMetric === 'revenue') return formatCurrencyCompact(v);
    if (weeklyMetric === 'conversionRate') return `${Number(v).toFixed(1)}%`;
    return formatStat(v);
  };

  return (
    <div>
      <div className="flex gap-2 mb-3">
        {metricOptions.map(opt => (
          <button
            key={opt.key}
            onClick={() => onWeeklyMetricChange(opt.key)}
            className={`text-xs px-3 py-1 rounded-full transition-colors ${weeklyMetric === opt.key ? 'bg-blue-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}
          >
            {opt.label}
          </button>
        ))}
      </div>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead>
            <tr>
              <th className="text-left text-[10px] font-semibold text-gray-400 uppercase tracking-wider p-2 w-16">Week</th>
              {DAY_LABELS.map(d => (
                <th key={d} className="text-center text-[10px] font-semibold text-gray-400 uppercase tracking-wider p-2">{d}</th>
              ))}
              <th className="text-right text-[10px] font-semibold text-gray-400 uppercase tracking-wider p-2">Total</th>
            </tr>
          </thead>
          <tbody>
            {weeklyRevenueByWeekday.map((week, i) => (
              <tr key={i}>
                <td className="text-xs font-medium text-gray-600 p-2">{week.weekKey}</td>
                {week.days.map((val, j) => (
                  <td key={j} className="p-1">
                    <div className={`rounded-lg p-2 text-center text-[10px] font-semibold ${getHeatColor(val, maxVal)}`}>
                      {formatVal(val)}
                    </div>
                  </td>
                ))}
                <td className="text-right text-xs font-bold text-gray-800 p-2">{formatVal(week.total)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
